(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		if (!imagesWrapper) return;

		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", () => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const getModalInitialSlideIndex = (modal, opener) => {
		if (!opener) return 0;

		const mediaId = opener.getAttribute("data-media-id");
		if (!mediaId) return 0;

		const slides = modal.querySelectorAll(
			".js-modal-mobile-swiper .swiper-slide"
		);

		for (let index = 0; index < slides.length; index++) {
			if (slides[index].querySelector(`[data-media-id="${mediaId}"]`)) {
				return index;
			}
		}

		return 0;
	};

	const MIN_SLIDE_ZOOM = 1;
	const MAX_SLIDE_ZOOM = 4;
	const SLIDE_DOUBLE_TAP_DELAY = 300;
	const SLIDE_TAP_THRESHOLD = 10;

	const createSlideZoomState = () => ({
		scale: 1,
		tx: 0,
		ty: 0,
		startDist: 0,
		startScale: 1,
		lastPanX: 0,
		lastPanY: 0,
		touchStartX: 0,
		touchStartY: 0,
		lastTapTime: 0,
		isPinching: false,
		isPanning: false,
	});

	const getSlideZoomState = (img) => {
		if (!img._slideZoomState) {
			img._slideZoomState = createSlideZoomState();
		}

		return img._slideZoomState;
	};

	const getTouchDistance = (t1, t2) =>
		Math.hypot(t1.clientX - t2.clientX, t1.clientY - t2.clientY);

	const applySlideZoom = (img, state) => {
		img.style.transform = `translate(${state.tx}px, ${state.ty}px) scale(${state.scale})`;
		img.classList.toggle("is-slide-zoomed", state.scale > 1);
	};

	const clampSlidePan = (img, state) => {
		const maxTx = (img.offsetWidth * (state.scale - 1)) / 2;
		const maxTy = (img.offsetHeight * (state.scale - 1)) / 2;
		state.tx = Math.min(maxTx, Math.max(-maxTx, state.tx));
		state.ty = Math.min(maxTy, Math.max(-maxTy, state.ty));
	};

	const resetSlideZoom = (img, animate = false) => {
		// resets zoom
		if (!img) return;

		const state = getSlideZoomState(img);

		if (animate) {
			img.classList.add("is-slide-resetting");
		}

		state.scale = 1;
		state.tx = 0;
		state.ty = 0;
		state.startDist = 0;
		state.startScale = 1;
		state.isPinching = false;
		state.isPanning = false;
		img.style.transform = "";
		img.classList.remove("is-slide-zoomed");

		if (animate) {
			setTimeout(() => img.classList.remove("is-slide-resetting"), 200);
		}
	};

	const resetAllSlideZooms = (modal) => {
		if (!modal) return;

		modal
			.querySelectorAll(".js-modal-mobile-swiper img.js-image-zoom")
			.forEach((img) => resetSlideZoom(img));
	};

	const isSlideZoomed = (modal) => {
		const activeImg = modal.querySelector(
			".js-modal-mobile-swiper .swiper-slide-active img.js-image-zoom"
		);

		return activeImg && getSlideZoomState(activeImg).scale > 1.01;
	};

	const setModalTouchSwipeLocked = (modal, locked) => {
		const swiper = modal.mobileMainSwiper;

		if (swiper) {
			swiper.allowTouchMove = !locked;
		}
	};

	const bindModalSlidePinchZoom = (modal) => {
		const mainEl = modal.querySelector(".js-modal-mobile-swiper");
		if (!mainEl || modal.dataset.slidePinchZoomInit === "true") return;

		modal.dataset.slidePinchZoomInit = "true";

		const getActiveImg = () =>
			mainEl.querySelector(".swiper-slide-active img.js-image-zoom");

		mainEl.addEventListener(
			"touchstart",
			(e) => {
				const activeImg = getActiveImg();
				if (!activeImg) return;

				const state = getSlideZoomState(activeImg);

				if (e.touches.length === 2) {
					e.preventDefault();
					state.isPinching = true;
					state.isPanning = false;
					state.startDist = getTouchDistance(
						e.touches[0],
						e.touches[1]
					);
					state.startScale = state.scale;
					setModalTouchSwipeLocked(modal, true);
					return;
				}

				if (e.touches.length === 1 && state.scale > 1) {
					e.preventDefault();
					state.isPanning = true;
					state.lastPanX = e.touches[0].clientX;
					state.lastPanY = e.touches[0].clientY;
					state.touchStartX = e.touches[0].clientX;
					state.touchStartY = e.touches[0].clientY;
					setModalTouchSwipeLocked(modal, true);
				}
			},
			{ passive: false, capture: true }
		);

		mainEl.addEventListener(
			"touchmove",
			(e) => {
				const activeImg = getActiveImg();
				if (!activeImg) return;

				const state = getSlideZoomState(activeImg);

				if (e.touches.length === 2) {
					e.preventDefault();

					if (!state.isPinching || state.startDist <= 0) {
						state.isPinching = true;
						state.startDist = getTouchDistance(
							e.touches[0],
							e.touches[1]
						);
						state.startScale = state.scale;
					}

					const dist = getTouchDistance(e.touches[0], e.touches[1]);
					state.scale = Math.min(
						MAX_SLIDE_ZOOM,
						Math.max(
							MIN_SLIDE_ZOOM,
							state.startScale * (dist / state.startDist)
						)
					);
					clampSlidePan(activeImg, state);
					applySlideZoom(activeImg, state);
					setModalTouchSwipeLocked(modal, state.scale > 1);
					return;
				}

				if (e.touches.length === 1 && state.isPanning && state.scale > 1) {
					e.preventDefault();
					const touch = e.touches[0];
					state.tx += touch.clientX - state.lastPanX;
					state.ty += touch.clientY - state.lastPanY;
					state.lastPanX = touch.clientX;
					state.lastPanY = touch.clientY;
					clampSlidePan(activeImg, state);
					applySlideZoom(activeImg, state);
				}
			},
			{ passive: false, capture: true }
		);

		const handleTouchEnd = (e) => {
			const activeImg = getActiveImg();
			if (!activeImg) return;

			const state = getSlideZoomState(activeImg);

			if (e.touches.length < 2) {
				state.isPinching = false;
				state.startDist = 0;
			}

			if (e.touches.length > 0) return;

			state.isPanning = false;

			if (state.scale <= 1.01) {
				resetSlideZoom(activeImg);
				setModalTouchSwipeLocked(modal, false);
				return;
			}

			setModalTouchSwipeLocked(modal, true);

			const movedX = Math.abs(state.lastPanX - state.touchStartX);
			const movedY = Math.abs(state.lastPanY - state.touchStartY);
			const isTap =
				movedX < SLIDE_TAP_THRESHOLD && movedY < SLIDE_TAP_THRESHOLD;

			if (!isTap) return;

			const now = Date.now();

			if (now - state.lastTapTime < SLIDE_DOUBLE_TAP_DELAY) {
				resetSlideZoom(activeImg, true);
				setModalTouchSwipeLocked(modal, false);
				state.lastTapTime = 0;
				return;
			}

			state.lastTapTime = now;
		};

		mainEl.addEventListener("touchend", handleTouchEnd, {
			passive: true,
			capture: true,
		});
		mainEl.addEventListener("touchcancel", handleTouchEnd, {
			passive: true,
			capture: true,
		});
	};

	const destroyModalMobileSwiper = (modal) => {
		if (!modal) return;

		resetAllSlideZooms(modal);
		setModalTouchSwipeLocked(modal, false);

		if (modal.mobileMainSwiper) {
			modal.mobileMainSwiper.destroy(true, true);
			modal.mobileMainSwiper = null;
		}

		if (modal.mobileThumbsSwiper) {
			modal.mobileThumbsSwiper.destroy(true, true);
			modal.mobileThumbsSwiper = null;
		}
	};

	const initModalMobileSwiper = (modal, opener) => {
		if (!modal || typeof Swiper === "undefined") return;
		if (!window.matchMedia("(max-width: 989px)").matches) return;

		const mainEl = modal.querySelector(".js-modal-mobile-swiper");
		const thumbsEl = modal.querySelector(".js-modal-mobile-thumbs");
		if (!mainEl) return;

		destroyModalMobileSwiper(modal);

		if (thumbsEl) {
			modal.mobileThumbsSwiper = new Swiper(thumbsEl, {
				slidesPerView: "auto",
				spaceBetween: 8,
				freeMode: true,
				watchSlidesProgress: true,
				slideToClickedSlide: true,
			});
		}

		const swiperOptions = {
			initialSlide: getModalInitialSlideIndex(modal, opener),
			slidesPerView: 1,
			spaceBetween: 0,
		};

		if (modal.mobileThumbsSwiper) {
			swiperOptions.thumbs = {
				swiper: modal.mobileThumbsSwiper,
				autoScrollOffset: 1,
			};
		}

		const prevEl = modal.querySelector(".js-modal-prev");
		const nextEl = modal.querySelector(".js-modal-next");

		if (prevEl && nextEl) {
			swiperOptions.navigation = {
				nextEl,
				prevEl,
			};
		}

		modal.mobileMainSwiper = new Swiper(mainEl, swiperOptions);

		modal.mobileMainSwiper.on("touchMove", () => {
			if (isSlideZoomed(modal)) {
				setModalTouchSwipeLocked(modal, true);
			}
		});

		modal.mobileMainSwiper.on("slideChange", () => {
			resetAllSlideZooms(modal);
			setModalTouchSwipeLocked(modal, false);
		});

		bindModalSlidePinchZoom(modal);

		modal.mobileMainSwiper.update();
		if (modal.mobileThumbsSwiper) {
			modal.mobileThumbsSwiper.update();
		}
	};

	window.destroyModalMobileSwiper = destroyModalMobileSwiper;
	window.initModalMobileSwiper = initModalMobileSwiper;

	const initDesktopFloatedPopup = () => {
		const stickyBar = document.querySelector(".product__popup.sticky-bar");
		if (!stickyBar) return;

		const addToCartButton = Array.from(
			document.querySelectorAll('.product-form__submit[name="add"]')
		).find((button) => !button.closest(".product__popup"));
		if (!addToCartButton) return;

		const footer = document.querySelector("footer");
		let isButtonVisible = false;
		let isFooterVisible = false;

		const updateStickyState = () => {
			const shouldShow = !isButtonVisible && !isFooterVisible;
			stickyBar.classList[shouldShow ? "add" : "remove"]("active");
		};

		const buttonObserver = new IntersectionObserver(
			(entries) => {
				const [entry] = entries;
				if (!entry) return;

				isButtonVisible = entry.isIntersecting;
				updateStickyState();
			},
			{
				threshold: 0.05,
			}
		);
		buttonObserver.observe(addToCartButton);

		if (footer) {
			const footerObserver = new IntersectionObserver(
				(entries) => {
					const [entry] = entries;
					if (!entry) return;

					isFooterVisible = entry.isIntersecting;
					updateStickyState();
				},
				{
					threshold: 0.01,
				}
			);
			footerObserver.observe(footer);
		}

		updateStickyState();
	};


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		initDesktopFloatedPopup();
	});

	initProductAccordion();
	initZoomImage();
	initDesktopFloatedPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
				this.syncFloatedFormToPdpVariant();
			});
	}

	// Floated form yüklendiğinde PDP'deki seçili varyantı floated form dropdown'larına uygular
	syncFloatedFormToPdpVariant() {
		const mainVariantRadios = Array.from(document.querySelectorAll("variant-radios")).find(
			(r) => !this.contains(r)
		);
		if (!mainVariantRadios) return;

		const floatedVariantRadios = this.querySelector("variant-radios");
		if (!floatedVariantRadios) return;

		mainVariantRadios.querySelectorAll(".product-form__controls--dropdown").forEach((fieldset) => {
			const checkedInput = fieldset.querySelector("input:checked");
			if (!checkedInput) return;
			const name = checkedInput.getAttribute("name");
			const value = checkedInput.value;
			const labelText = checkedInput.closest("li")?.textContent?.trim() || value;

			const otherInput = floatedVariantRadios.querySelector(
				`input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`
			);
			if (!otherInput) return;
			otherInput.checked = true;
			const otherFieldset = otherInput.closest(".product-form__controls--dropdown");
			const span = otherFieldset?.querySelector(".select-label span");
			if (span) {
				span.textContent = labelText;
				span.setAttribute("title", labelText);
			}
		});

		// Variant değişikliğini form mantığına ileti (fiyat, URL vb.)
		floatedVariantRadios.querySelector("input:checked")?.dispatchEvent(
			new Event("change", { bubbles: true })
		);
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		// Tutulacak selectors'lar
		const keepSelectors = ['.product-parameters', '.product__buy_buttons'];

		// Product element'inin tüm direkt child'larını al
		const children = Array.from(this.productElement.querySelector('.product__info-main_content').children);
		children.forEach((child) => {
			const hasKeepSelectors = keepSelectors.some((keepSelector) => {
				if (keepSelector.startsWith('.')) {
					return child.classList.contains(keepSelector.substring(1));
				}
				return child.querySelector(keepSelector) !== null;
			});

			if (hasKeepSelectors) {
				return;
			}

			child.remove();
		});

		// Özel durumlar: Her zaman silinmesi gerekenler
		const favoriteButtonPdp = this.productElement.querySelector("[data-favorite-button-pdp]");
		if (favoriteButtonPdp) favoriteButtonPdp.remove();
		
		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();

		const floatedFormHideElements = this.productElement.querySelectorAll(".floated-form-hide");
		floatedFormHideElements.forEach((el) => el.remove());
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
